import React from "react";
import Select from "react-select";

export const AffiliateDropdown = ({
  affiliatesList = [],
  handleAffiliateChange,
}) => {
  let options = [];

  if (affiliatesList && affiliatesList.length > 0) {
    affiliatesList.forEach((aff) => {
      if (aff.affiliate.status === "enabled") {
        let affiliate = {};

        affiliate.value = {
          id: aff.affiliate.affiliateId,
          pos: aff.pointOfSaleId,
          client: aff.affiliate.clientId,
          externalAffId: aff.affiliate.externalAffiliateId,
        };

        let name = aff.affiliate.clientName
          ? " - " + aff.affiliate.clientName
          : "";
        affiliate.label = aff.affiliate.name + name;

        options.push(affiliate);
      }
    });
  }

  return (
    <Select
      defaultValue={options[0]}
      options={options}
      onChange={(e) => handleAffiliateChange(e, affiliatesList)}
    />
  );
};
